import {Module} from 'vuex';
import {state} from './state';
//import {actions} from './actions'
import {mutations} from './mutations';
import {MaestroKtb} from './types';
import {RootState} from '@/store/types';
const namespaced: boolean=true;

export const maestroKtb:Module<MaestroKtb,RootState>={
    namespaced,
    state,
    mutations
    
}